/* eslint-disable @typescript-eslint/no-empty-function */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { City, PhoneInputConfig, SeoTags, CitizenshipCountry } from '../../../base/interfaces/config';

export interface WorkerAppState {
    initialized: boolean;
    config: Config;
    citySearchOptions: City[] | null;
}

export interface Config {
    phoneInputConfig: PhoneInputConfig;
    seoTags: SeoTags;
    citizenshipCountries: CitizenshipCountry[];
}

const phoneInputConfigInitialState = {
    countries: [],
    preferredCountries: [],
    localization: {},
};

const seoTagsInitialState = {
    title: '',
    description: '',
};

const initialState: WorkerAppState = {
    initialized: false,
    config: {
        phoneInputConfig: phoneInputConfigInitialState,
        seoTags: seoTagsInitialState,
        citizenshipCountries: [],
    },
    citySearchOptions: null,
};

export const workerAppSlice = createSlice({
    name: 'worker-app',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        init: () => {},
        setInitialized: (state, action: PayloadAction<boolean>) => {
            state.initialized = action.payload;
        },
        getConfigSuccess: (state, action: PayloadAction<Config>) => {
            state.config = action.payload;
        },
        sendConfirmationCode: {
            reducer: () => {},
            prepare: (phone: string, recaptchaToken: string | null, callback?: () => void) => ({
                payload: { phone, recaptchaToken, callback },
            }),
        },
        citySearch: {
            reducer: () => {},
            prepare: (search: string) => ({ payload: search }),
        },
        setCitySearch: (state, action: PayloadAction<City[] | null>) => {
            state.citySearchOptions = action.payload;
        },
    },
});

export const workerAppActions = workerAppSlice.actions;
export const workerAppReducer = workerAppSlice.reducer;
